var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-1 bg-gray-500 w-full"},[_c('span',{staticClass:"block h-1 bg-yellow-500",style:({ width: _vm.scalePercentage, transition: 'width .3s linear' }),attrs:{"data-scale":_vm.scalePercentage}})])}
var staticRenderFns = []

export { render, staticRenderFns }